import { TEXT_MAX_LENGTH, HORIZONTAL_LINE_LENGTH } from './BreadCrumbConst';
import R from '../../../core-res/R';
import { isActive, isCompleted } from './getItemStatus';
export const getTextMaxWidth = (index, lastItemIndex) => {
    let maxWidth = TEXT_MAX_LENGTH;
    if (index === 0 || index === lastItemIndex)
        maxWidth = maxWidth + HORIZONTAL_LINE_LENGTH;
    return maxWidth;
};
export const getListItemStyle = (index, lastItemIndex) => {
    switch (index) {
        case 0:
        case lastItemIndex:
            return;
        default:
            return { justifyContent: 'center' };
    }
};
export const getTextWrapperStyle = (index, lastItemIndex) => {
    switch (index) {
        case 0:
            return { paddingBottom: R.spacing.xs };
        case lastItemIndex:
            return {
                borderLeftWidth: 0,
                paddingTop: R.spacing.xs,
            };
        default:
            return { paddingVertical: R.spacing.xs };
    }
};
export const getIndicatorPosition = index => {
    const style = {
        position: 'absolute',
        left: R.spacing.s + 2,
    };
    switch (index) {
        case 0:
            return style;
        default:
            return Object.assign({}, style, { top: R.spacing.xs });
    }
};
export const getTextStyle = (index, activeEventIndex) => {
    if (isActive(index, activeEventIndex))
        return { fontWeight: '600' };
    if (isCompleted(index, activeEventIndex))
        return { textDecorationLine: 'line-through' };
};
